import React from 'react';

const ContactArea = () => {
  return (
    <>
    
    
    
  
    <div className="space overflow-hidden contact-area-1 position-relative z-index-common">
      <div className="container">
        <div className="contact-wrap1">
          <div className="row gx-60 gy-40">
            <div className="col-xl-4 col-lg-5">
              {/* Address Section */}
              <div className="contact-feature">
                <div className="box-icon">
                  <i className="fas fa-map-location-dot"></i>
                </div>
                <div className="media-body">
                  <h3 className="box-title">Address</h3>
                  <p className="box-text">Kurenda Road, Tahsil + P.O. - Paraswada,
                  District – Balaghat, Madhya Pradesh – Pin - 481556</p>
                </div>
              </div>
              {/* Phone Section */}
              <div className="contact-feature">
                <div className="box-icon" data-theme-color="#FFAC00">
                  <i className="fas fa-phone-volume"></i>
                </div>
                <div className="media-body">
                  <h3 className="box-title">Phone</h3>
                  <p className="box-text">
                    <a href="tel:16363599852">+91-9424906514</a>
                  </p>
                  <p className="box-text">
                    <a href="tel:16363599852">9424385729,9399091525</a>
                  </p>
                </div>
              </div>
              {/* Email Section */}
              <div className="contact-feature">
                <div className="box-icon" data-theme-color="#122F2A">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="media-body">
                  <h3 className="box-title">Email</h3>
                  <p className="box-text">
                    <a href="mailto:gramsevatrust@gmail.com">gramsevatrust@gmail.com</a>
                  </p>
                  <p className="box-text">
                    <a href="mailto:gst_balaghat@yahoo.co.in">gst_balaghat@yahoo.co.in</a>
                  </p>
                </div>
              </div>
              {/* Questions Section */}
              <div className="contact-feature" data-theme-color="#FF5528">
                <div className="box-icon">
                  <i className="fas fa-comment-question"></i>
                </div>
                <div className="media-body">
                  <h3 className="box-title">Have Questions?</h3>
                  <p className="box-text">
                    Discover more by visiting us or joining our community
                  </p>
                </div>
              </div>
            </div>
            {/* Map Section */}
            <div className="col-xl-8 col-lg-7">
              <div className="contact-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3644.7310056272386!2d89.2286059153658!3d24.00527418490799!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39fe9b97badc6151%3A0x30b048c9fb2129bc!2sAngfuztheme!5e0!3m2!1sen!2sbd!4v1651028958211!5m2!1sen!2sbd"
                  allowFullScreen=""
                  loading="lazy"
                  title="Google Map"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        {/* Contact Form */}
        <div className="contact-page-form-wrap space-top">
          <div className="row gy-40">
            <div className="col-xl-6 align-self-end">
              <div className="contact-thumb1-1">
                <img src="assets/img/normal/contact_1_1.png" alt="Contact Thumbnail" />
              </div>
            </div>
            <div className="col-xl-6">
              <div className="contact-form-v1 contact-page-form">
                <form
                  action="https://html.themeholy.com/donat/demo/mail.php"
                  method="POST"
                  className="contact-form style-border ajax-contact"
                >
                  <div className="row">
                    <div className="form-group style-border col-12">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        id="name"
                        placeholder="Your Name"
                      />
                    </div>
                    <div className="form-group style-border col-12">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        placeholder="Email Address"
                      />
                    </div>
                    <div className="form-group style-border col-12">
                      <input
                        type="number"
                        className="form-control"
                        name="number"
                        id="number"
                        placeholder="Phone Number"
                      />
                    </div>
                    <div className="form-group style-border col-12">
                      <textarea
                        name="message"
                        id="message"
                        cols="30"
                        rows="3"
                        className="form-control"
                        placeholder="Type Your Message"
                      ></textarea>
                    </div>
                    <div className="form-btn col-12">
                      <button className="th-btn">Send a Message</button>
                    </div>
                  </div>
                  <p className="form-messages mb-0 mt-3"></p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

<section className="about-section inner-page">
<div className="container">
<h1>Contact Us</h1>
  <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
     

      <section style={{ marginBottom: '30px' }}>
          <h2>Registered Office</h2>
          <p>Kurenda Road, Tahsil + P.O. - Paraswada,</p>
          <p>District – Balaghat, Madhya Pradesh – Pin - 481556</p>
          <p>Email: 
              <a href="mailto:gramsevatrust@gmail.com" style={{ marginLeft: '5px' }}>gramsevatrust@gmail.com</a>, 
              <a href="mailto:gst_balaghat@yahoo.co.in" style={{ marginLeft: '5px' }}>gst_balaghat@yahoo.co.in</a>
          </p>
          <p>Mobile: <a href="tel:+919424906514">+91-9424906514</a></p>
      </section>

      <section>
          <h2>Branch Office</h2>
          <p>GRAM SEVA TRUST</p>
          <p>Chandrahas Patel</p>
          <p>Behind Khermai Mandir, Katra Road</p>
          <p>District-Mandla, Madhya Pradesh Pin-481661</p>
          <p>Contact No.: 
              <a href="tel:+919424385729" style={{ marginLeft: '5px' }}>9424385729</a>, 
              <a href="tel:+919399091525" style={{ marginLeft: '5px' }}>9399091525</a>
          </p>
      </section>
  </div>
  </div>
 </section>
 <div className='col-md-3'>

 </div>
 <div className='col-md-6'>
 

 </div>
 <div className='col-md-3'>

</div>

</>
  );
};

export default ContactArea;
